import styles from './AboutSection.module.css';

export default function AboutSection({content}) {
    return (
        // The id is the target of the nav's About link and of the old /home/southafrica/about/ redirect.
        <section id="ch-home-about" className={styles.section} aria-labelledby="home-about">
            <div className={styles.inner}>
                <h2 id="home-about" className={styles.heading}>{content.heading}</h2>
                <div className={styles.copy}>
                    {content.paragraphs.map((paragraph, index) => (
                        <p key={paragraph.slice(0, 40)}
                           className={index === 0 ? styles.lead : styles.paragraph}>
                            {paragraph}
                        </p>
                    ))}
                </div>
            </div>
        </section>
    );
}
